import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import Img from '../../../Img';
import PrimaryContactEditModal from './components/PrimaryContactEditModal';
import PrimaryContactInfoModal from './components/PrimaryContactInfoModal';
import ProspectSectionRow from '../components/ProspectSectionRow';
import styles from '../collegeProspectTab.scss';

const TESTID_PREFIX = 'profile.college-prospect.primary-contact';

const renderRow = (label, value, testId) => (
    <ProspectSectionRow
        label={label}
        value={value}
        testId={testId}
        testIdPrefix={TESTID_PREFIX}
    />
);

const PrimaryContact = () => {
    const profileData = useSelector((state) => state.profile?.data) || {};
    const authUser = useSelector((state) => state.auth?.user);
    const studentInfo = profileData.studentInfo || {};
    const coach = studentInfo.coach || {};
    const isOwnProfile = !!authUser && !!profileData.memberId && authUser.id === profileData.memberId;

    const fullName = [coach.firstName, coach.lastName].filter(Boolean).join(' ');

    const [isEditing, setIsEditing] = useState(false);
    const [isInfoOpen, setIsInfoOpen] = useState(false);

    return (
        <div className={styles.academicsSection} data-testid={`${TESTID_PREFIX}.container`}>
            <div className={styles.academicsHeader}>
                <div className={styles.academicsTitleBlock}>
                    <div className={styles.academicsTitleRow}>
                        <h6
                            className={styles.academicsTitle}
                            data-testid={`${TESTID_PREFIX}.title`}
                        >
                            Primary Contact
                        </h6>
                        <button
                            type="button"
                            className={styles.academicsInfoBtn}
                            onClick={() => setIsInfoOpen(true)}
                            aria-label="About Primary Contact"
                            data-testid={`${TESTID_PREFIX}.info-btn`}
                        >
                            <Img
                                src="/img/v4/info-icon.svg"
                                alt=""
                                className={styles.academicsInfoIcon}
                            />
                        </button>
                    </div>
                    <div
                        className={styles.academicsSubtitle}
                        data-testid={`${TESTID_PREFIX}.subtitle`}
                    >
                        Viewable by college coaches.
                    </div>
                </div>
                {isOwnProfile && (
                    <button
                        type="button"
                        className={styles.academicsEditBtn}
                        onClick={() => setIsEditing(true)}
                        data-testid={`${TESTID_PREFIX}.edit-btn`}
                    >
                        <Img
                            src="/img/v4/pen.svg"
                            alt=""
                            className={styles.academicsEditIcon}
                        />
                        <span data-testid={`${TESTID_PREFIX}.edit-btn.text`}>Edit</span>
                    </button>
                )}
            </div>

            <div className={styles.academicsCard}>
                <div className={styles.academicsBody}>
                    {renderRow('Name', fullName, 'name')}
                    {renderRow('Relationship', coach.relationship, 'relationship')}
                    {renderRow('Email', coach.email, 'email')}
                    {renderRow('Phone Number', coach.phone, 'phone-number')}
                </div>
            </div>

            {isEditing && isOwnProfile && (
                <PrimaryContactEditModal onClose={() => setIsEditing(false)} />
            )}
            {isInfoOpen && (
                <PrimaryContactInfoModal onClose={() => setIsInfoOpen(false)} />
            )}
        </div>
    );
};

export default PrimaryContact;
